// Card Image Imports for Set 1
// Import all available card images
// Naming convention: {cardNumber}_{cardname}.png

// Common cards (1-25)
import card1 from './1/1_notepad_of_verse.png';
import card2 from './1/2_quill_of_dreams.png';
import card3 from './1/3_bottle_of_ink.png';
import card4 from './1/4_wax_seal_of_words.png';
import card5 from './1/5_the_open_journal.png';
import card6 from './1/6_the_scattered_pages.png';
import card7 from './1/7_the_broken_quill.png';
import card8 from './1/8_the_inkpots_shadow.png';
import card9 from './1/9_candle_and_verse.png';
import card10 from './1/10_pressed_petal_letter.png';
import card11 from './1/11_the_writers_glasses.png';
import card12 from './1/12_folded_thoughts.png';
import card13 from './1/13_the_ink_spill.png';
import card14 from './1/14_tea_beside_the_pen.png';
import card15 from './1/15_the_wax_stick.png';
import card16 from './1/16_paperweight_owl.png';
import card17 from './1/17_the_empty_page.png';
import card18 from './1/18_ink_and_petals.png';
import card19 from './1/19_the_old_desk.png';
import card20 from './1/20_the_candle_stub.png';
import card21 from './1/21_parchment_roll.png';
import card22 from './1/22_the_bookmark.png';
import card23 from './1/23_feather_and_flame.png';
import card24 from './1/24_inkstone_and_brush.png';
import card25 from './1/25_final_line.png';

// Uncommon cards (26-40)
import card26 from './1/26_foggy_bridge.png';
import card27 from './1/27_lantern_square.png';
import card28 from './1/28_poets_alley.png';
import card29 from './1/29_the_carriage_of_letters.png';
import card30 from './1/30_riverside_library.png';
import card31 from './1/31_the_clocktower_quill.png';
import card32 from './1/32_the_old_typewriter_shop.png';
import card33 from './1/33_the_inkstone_cafe.png';
import card34 from './1/34_the_writers_garden.png';
import card35 from './1/35_the_balcony_of_thought.png';
import card36 from './1/36_the_rainy_crossing.png';
import card37 from './1/37_the_archivists_gate.png';
import card38 from './1/38_the_train_of_words.png';
import card39 from './1/39_the_bicycle_messenger.png';
import card40 from './1/40_the_candlelit_reading_room.png';

// Rare cards (41-47)
import card41 from './1/41_ink_phoenix.png';
import card42 from './1/42_queens_griffin.png';
import card43 from './1/43_stone_serpent.png';
import card44 from './1/44_ash_wolf.png';
import card45 from './1/45_moon_stag.png';
import card46 from './1/46_shadow_roc.png';
import card47 from './1/47_glass_lion.png';

// Epic cards (48-49)
import card48 from './1/48_poet_of_twilight.png';
import card49 from './1/49_muse_of_ash_and_paper.png';

// Legendary card (50)
import card50 from './1/50_ink_dragon.png';

// Card image mapping for Set 1
export const CARD_IMAGES_SET_1 = {
  1: card1,
  2: card2,
  3: card3,
  4: card4,
  5: card5,
  6: card6,
  7: card7,
  8: card8,
  9: card9,
  10: card10,
  11: card11,
  12: card12,
  13: card13,
  14: card14,
  15: card15,
  16: card16,
  17: card17,
  18: card18,
  19: card19,
  20: card20,
  21: card21,
  22: card22,
  23: card23,
  24: card24,
  25: card25,
  26: card26,
  27: card27,
  28: card28,
  29: card29,
  30: card30,
  31: card31,
  32: card32,
  33: card33,
  34: card34,
  35: card35,
  36: card36,
  37: card37,
  38: card38,
  39: card39,
  40: card40,
  41: card41,
  42: card42,
  43: card43,
  44: card44,
  45: card45,
  46: card46,
  47: card47,
  48: card48,
  49: card49,
  50: card50,
};

/**
 * Get card image URL by set number and card number
 * @param {number} setNumber - The set number
 * @param {number} cardNumber - The card number within the set
 * @returns {string|null} - The image URL or null if not available
 */
export function getCardImageUrl(setNumber, cardNumber) {
  if (setNumber === 1) {
    return CARD_IMAGES_SET_1[cardNumber] || null;
  }
  // Add more sets here as they become available
  return null;
}
